import React from 'react';
import { Theme } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
// @ts-ignore
import Plot from 'react-plotly.js';
// @ts-ignore
import { AxisType } from 'plotly.js';

interface PlotProps {
  xs: number[][];
  ys: number[][];
  xLabel?: string;
  yLabel?: string;
  theme?: Theme;
  xAxisType?: AxisType;
}

const DistributionPlot = (props: PlotProps) => {
  const {
    xs, ys, xLabel, yLabel, theme, xAxisType,
  } = props;

  return (
    <Plot
      style={{ width: '100%' }}
      config={{
        displaylogo: false,
        autosizable: true,
        responsive: false,
      }}
      data={xs.map((x, index) => ({
        x,
        y: ys[index],
        type: 'scatter',
        mode: 'lines+markers',
      }))}
      layout={{
        margin: {
          t: 10,
        },
        paper_bgcolor: 'transparent',
        plot_bgcolor: 'transparent',
        font: {
          color: theme.palette.text.primary,
        },
        xaxis: {
          color: theme.palette.text.primary,
          title: xLabel || 'x',
          type: xAxisType || 'linear',
          autorange: true,
        },
        yaxis: {
          color: theme.palette.text.primary,
          title: yLabel || 'y',
          type: 'linear',
          autorange: true,
        },
        showlegend: true,
        legend: {
          x: 0,
          y: 1,
        },
      }}
    />
  );
};

export default withStyles({}, { withTheme: true })(DistributionPlot);
